// extracted by mini-css-extract-plugin
export default {"ButtonCheckBox":"CheckBoxGroup_ButtonCheckBox__4YosX","tag":"CheckBoxGroup_tag__TMdU+","disabled":"CheckBoxGroup_disabled__hwdib","checked":"CheckBoxGroup_checked__UauFl"};